/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, November 23rd 2021, 8:40:51 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { OSLoadingButton, VerticalStackWidget, FormControl } from "ui-widgets";
import { OSAPIForm, TextFormInput } from "ui-widgets/forms";
import { useResetPasswordAPIForm } from "authentication/services/AuthAPI";
import { ResetPasswordInput } from "lib/schemas";
import { LoginLink } from "./LoginLink";
import { AdminSignupLink } from "./AdminSignupLink";
import { AuthFooter } from "./AuthFooter";

export const ResetPasswordForm = () => {
  const { useAPIFormReturn } = useResetPasswordAPIForm();

  return (
    <>
      {/* <div className="auth-brand-wrapper">
        <img className="image-style-A sidebar-logo" src="/img/onestop-full-logo.svg" alt="logo" />
      </div> */}

      <div className="auth-form-box">
        <div className="auth-title-wrapper">
          <h1>Reset Your Password</h1>
          <p>Enter your email address to get a reset link</p>
        </div>

        <div className="form-fields-A">
          <OSAPIForm useAPIFormReturn={useAPIFormReturn} showSubmitButton={false} alertProps={{ horizontal: "center" }}>
            <div className="main-form-fields">
              <TextFormInput<ResetPasswordInput> schema_field_key="email" label="Email Address" fullWidth />

              <FormControl>
                <VerticalStackWidget>
                  <OSLoadingButton
                    className="button-style-A"
                    variant="contained"
                    size="large"
                    type="submit"
                    color="primary"
                    isLoading={useAPIFormReturn.isSendingDataToAPI}
                  >
                    Go
                  </OSLoadingButton>
                </VerticalStackWidget>
              </FormControl>

              <p className="auth-form-option">
                <LoginLink />
                &nbsp; &bull; &nbsp;
                <AdminSignupLink />
              </p>

              <AuthFooter />
            </div>
          </OSAPIForm>
        </div>
      </div>
    </>
  );
};
